import {DialogCloseButtonDefaultBox} from './dialog-close-button.default.box';

export const DialogCloseButtonBox = DialogCloseButtonDefaultBox;